import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GamasRoutingModule } from './gamas-routing.module';
import { EditGamaComponent } from './edit-gama/edit-gama.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PrintComponent } from './print/print.component';

@NgModule({
  declarations: [
    EditGamaComponent,
    PrintComponent
  ],
  imports: [
    CommonModule,
    GamasRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgApexchartsModule
  ]
})
export class GamasModule { }
